import { initPlausibleForms } from "./forms/analytics.mjs";

initPlausibleForms();
